import { put, takeLatest } from "redux-saga/effects";
import {
  fetchMessagesRequest,
  fetchMessagesSuccess,
  fetchMessagesFailure,
} from "./messagesSlice";
import { wizardURL } from "../../utils/config";
import TokenManager from "../../utils/tokenManager"; 

function* fetchMessagesSaga(action) {
  try {
    const { threadId } = action.payload;
    const token = TokenManager.getAccessToken(); 
    
    if (!token) throw new Error("Not authenticated");

    const response = yield fetch(
      `${wizardURL}/wizard/chat/history/${threadId}`, 
      {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}` 
        }
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to load messages: ${response.status}`);
    }

    const payload = yield response.json();
    const threadMessages = Array.isArray(payload.messages) ? payload.messages : [];

    const formattedMessages = threadMessages.map((msg, index) => ({
      id: msg.message_id || `${threadId}_${index}`,
      text: msg.content || "",
      sender: msg.role === "assistant" || msg.role === "bot" ? "bot" : "user",
      files: msg.files || [],
      timestamp: msg.created_at || new Date().toISOString(),
      metadata: msg.metadata || {},
    }));

    yield put(fetchMessagesSuccess({ threadId, messages: formattedMessages }));
  } catch (error) {
    console.error("Error in fetchMessagesSaga:", error);
    yield put(fetchMessagesFailure(error.message));
  }
}

export function* watchMessagesSaga() {
  yield takeLatest(fetchMessagesRequest, fetchMessagesSaga);
}